import { render, staticRenderFns } from "./BrandComponentList.vue?vue&type=template&id=b1965246&scoped=true"
import script from "./BrandComponentList.vue?vue&type=script&lang=js"
export * from "./BrandComponentList.vue?vue&type=script&lang=js"
import style0 from "./BrandComponentList.vue?vue&type=style&index=0&id=b1965246&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1965246",
  null
  
)

export default component.exports